import { CmsContent } from '@wolfdanepug/common-react'
import { NavLink } from 'react-router'
import { navIcons } from '../constants'
import { NavList } from './NavList'

export const Navigation = () => {
	return (
		<CmsContent name="AccountNavigation">
			<NavList icons={navIcons} sx={styles.nav} linkComponent={NavLink} />
		</CmsContent>
	)
}

const styles = {
	nav: {
		root: {},
		list: {},
		listItem: {
			borderRadius: 2,
			overflow: 'hidden'
		},
		listItemButton: {
			'&:hover': {
				backgroundColor: '#D2D0DB',
				'& .MuiTypography-root': {
					fontWeight: 600
				}
			},
			'&:active': {
				backgroundColor: '#D2D0DB',
				'& .MuiTypography-root': {
					fontWeight: 600
				}
			}
		},
		active: {
			backgroundColor: '#D2D0DB',
			fontWeight: 600
		},
		listItemIcon: {},
		icon: {},
		listItemText: {}
	}
}
